// Auto-generated from menu.spec.js
export default {
  "tagName": "ui-menu",
  "content": [
    "item"
  ],
  "types": [
    "selection",
    "sliding"
  ],
  "variations": [
    "evenly-spaced",
    "fitted",
    "vertical",
    "inset",
    "icon-only"
  ],
  "settings": [
    "items",
    "value",
    "tooltip-settings"
  ],
  "attributes": [
    "item",
    "selection",
    "sliding",
    "evenly-spaced",
    "fitted",
    "vertical",
    "inset",
    "icon-only",
    "items",
    "value",
    "tooltip-settings"
  ],
  "propertyTypes": {
    "item": "string",
    "selection": "boolean",
    "sliding": "boolean",
    "evenly-spaced": "boolean",
    "fitted": "boolean",
    "vertical": "boolean",
    "inset": "boolean",
    "icon-only": "boolean",
    "items": "array",
    "value": "string",
    "tooltip-settings": "object"
  },
  "defaultValues": {
    "items": [],
    "value": "",
    "tooltip-settings": {
      "duration": 0
    }
  }
};
